<template>
  <div
    class="modal fade"
    id="ingresarModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="ingresarModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div v-if="showLogin" class="ingreso-socios">
            <h2>INGRESO DE SOCIOS</h2>

            <div
              v-if="successMessage"
              class="alert alert-success"
              style="margin-bottom: 15px; text-align: center"
            >
              {{ successMessage }}
            </div>

            <div
              v-if="errorMessage"
              class="alert alert-danger"
              style="margin-bottom: 15px; text-align: center"
            >
              {{ errorMessage }}
            </div>

            <!--<input
              type="text"
              placeholder="DNI"
              v-model="loginForm.dni"
              class="form-control"
            />

            <input
              type="password"
              placeholder="Contraseña"
              v-model="loginForm.password"
              class="form-control"
            />

            <button
              type="button"
              class="btn-ingresar btn-login"
              @click="handleLogin"
              :disabled="loading"
            >
              <span v-if="loading">
                <i class="fa fa-spinner fa-spin"></i> Iniciando sesión...
              </span>
              <span v-else>INGRESAR</span>
            </button>
-->
            
            <button
              type="button"
              class="btn-ingresar btn-login"
              @click="handleKeycloakPopup"
              :disabled="loading"
            >
              <i class="fa-solid fa-id-card"></i> INGRESAR
            </button>
            <div class="divider">
              <span>O</span>
            </div>
            <button
              type="button"
              class="btn-ingresar btn-registrarse"
              @click="toggleLogin()"
            >
              REGISTRARSE
            </button>

             

            

            <a href="#" @click.prevent="openRecoverPasswordModal">¿Olvidó su contraseña? Haga click aquí</a>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { reactive, ref, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import * as bootstrap from "bootstrap";
import { login, loginWithToken } from "@/services/api/authService";
import { openLoginPopup } from "@/helpers/keycloakHelper";
//import { initiateKeycloakLogin } from "@/helpers/keycloakHelper";
import { useStore } from "vuex";

export default {
  name: "LoginModalComponent",
 setup(props, { emit, expose }) {
    const router = useRouter();
    const store = useStore();
    const showLogin = ref(true);
    const loading = ref(false);

    const loginForm = reactive({
      dni: "",
      password: "",
    });


    const errorMessage = ref("");
    const successMessage = ref("");
const modalInstance = ref(null);

    const initializeModal = () => {
      const modalElement = document.querySelector("#ingresarModal");
      if (modalElement) {
        modalInstance.value = new bootstrap.Modal(modalElement);
      }
    };

     const show = () => {
      if (!modalInstance.value) initializeModal();
      modalInstance.value.show();
    };

   const toggleLogin = () => {
      if (modalInstance.value) {
        modalInstance.value.hide();
        router.push({ path: "/socios-alta" });
      }
    };


    const openRecoverPasswordModal = () => {
      emit("openRecoverPassword");
    };

    const handleLogin = async () => {
      if (!loginForm.dni || !loginForm.password) {
        errorMessage.value = "Por favor, complete todos los campos.";
        return;
      }

      errorMessage.value = "";
      loading.value = true;

      try {
        let data = await login({
          dni: loginForm.dni,
          password: loginForm.password,
        });


        if (data.message === "First password change required") {
          window.location.href = data.reset_url;
          return;
        }

        finalizeLogin(data);
      } catch (error) {
        errorMessage.value =
          error.response?.data?.message ||
          "Error al iniciar sesión. Inténtelo de nuevo.";
        loading.value = false;
      }
    };

    const handleKeycloakPopup = () => {
      errorMessage.value = "";
      openLoginPopup();

      //initiateKeycloakLogin();
    };

    const handleMessage = async (event) => {
      // Validar origen por seguridad
      if (event.origin !== window.location.origin) return;

      if (event.data?.type === "keycloak-token") {
        const token = event.data.token;
        const idToken = event.data.idToken;
        loading.value = true;
        try {
          const response = await loginWithToken(token);
          const userData = response.data || response;
          
          // CRÍTICO: Adjuntamos los tokens al objeto de usuario para el Store
          // Nos aseguramos de extraer la data real si el backend devuelve un objeto anidado
          const finalData = userData.data || userData;
          
          const enrichedUser = {
            ...finalData,
            token: token,
            idToken: idToken || finalData.idToken // Preferimos el de Keycloak
          };

          // Si logramos entrar por SSO, limpiamos el flag de logout manual por si existía
          localStorage.removeItem("manual_logout");

          finalizeLogin(enrichedUser);
        } catch (error) {
          errorMessage.value = error || "Error al autenticar con Keycloak.";
          loading.value = false;
        }
      } else if (event.data?.type === "keycloak-error") {
        errorMessage.value = "Error en la autenticación de Keycloak.";
        loading.value = false;
      }
    };

    const finalizeLogin = (data) => {
      // Limpiamos la marca de logout manual para permitir detección SSO en el futuro
      localStorage.removeItem("manual_logout");
      sessionStorage.removeItem("manual_logout");

      // Guardamos en el Store (el Store persistirá esto en localStorage)
      store.dispatch("login", data);

      if (data.concessionaires?.length > 0) {
        store.commit("setSelectedConcessionaire", data.concessionaires[0]);
      }

      successMessage.value = "Inicio de sesión exitoso. Redirigiendo...";

      // Forzar recarga total de la página para asegurar consistencia de sesión
      setTimeout(() => {
        window.location.href = "/";
      }, 500);
    };

    onMounted(() => {
      window.addEventListener("message", handleMessage);
    });

    onUnmounted(() => {
      window.removeEventListener("message", handleMessage);
    });

    expose({ show });

    return {
       show,
      loading,
      showLogin,
      loginForm,
      errorMessage,
      successMessage,
      toggleLogin,
      openRecoverPasswordModal,
      handleLogin,
      handleKeycloakPopup,
      
    };
  },
};
</script>

<style scoped>
.modal-content {
  background: #2cbad2;
  padding: 50px;
}

.modal-body {
  text-align: center;
}

.modal-content h2 {
  color: #fff;
  text-align: center;
  margin-bottom: 30px;
  font-size: 2.4rem;
}

.mensaje-error,
.mensaje-error-recupero {
  color: #ff151b;
  margin-bottom: 10px;
  display: block;
}

.modal-content input {
  border-radius: 0;
  border: none;
  margin: 0 auto 20px auto;
  width: 60%;
}

.modal-content .btn-ingresar {
  background: #001f5b;
  color: #fff;
  border: none;
  margin: 10px auto;
  display: block;
  padding: 5px 30px;
  width: 250px;
}

.btn-keycloak {
  background: #f8f9fa !important;
  color: #001f5b !important;
  border: 1px solid #001f5b !important;
  font-weight: bold;
}

.btn-keycloak i {
  margin-right: 10px;
}

.divider {
  display: flex;
  align-items: center;
  text-align: center;
  color: #fff;
  margin: 15px auto;
  width: 60%;
}

.divider::before,
.divider::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #fff;
}

.divider:not(:empty)::before {
  margin-right: .5em;
}

.divider:not(:empty)::after {
  margin-left: .5em;
}

.modal-content a {
  color: #fff !important;
  text-align: center;
  width: 90%;
  margin: 0 auto;
  display: block;
}

:global(.modal-backdrop.show) {
  z-index: 1 !important;
  opacity: 0 !important;
  position: unset !important;
}
</style>
